import { EventForm } from '@/components/enc/event-form';
import { useParams } from 'react-router-dom';

const EditPage = () => {
  const { id } = useParams<{ id: string }>();

  return <EventForm key={id} id={id} />;
};

export default EditPage;
